import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent } from './map.component';

@NgModule({
	imports: [
		CommonModule,
	],
	exports: [
		MapComponent,
	],
	providers: [
	],
	declarations: [
		MapComponent,
	],
})
export class MapModule { }
